/**
 * CfssDashboardPage — CFSS Overview Dashboard
 *
 * MN 256B.85: Community First Services and Supports
 * Unified dashboard for all CFSS roles showing key metrics.
 *
 * Route: /cfss
 */

import React from 'react';
import {
  Container,
  Grid,
  Group,
  SimpleGrid,
  Stack,
  Text,
  ThemeIcon,
  Title,
} from '@mantine/core';
import { IconHome } from '@tabler/icons-react';
import {
  BudgetUtilizationWidget,
  EvvSummaryWidget,
  ServiceHoursWidget,
  SupervisionComplianceWidget,
} from './components';

export function CfssDashboardPage() {
  return (
    <Container size="xl" py="md">
      <Stack gap="lg">
        <Group gap="xs">
          <ThemeIcon size="lg" variant="light" color="teal">
            <IconHome size={20} />
          </ThemeIcon>
          <Stack gap={0}>
            <Title order={2}>CFSS Dashboard</Title>
            <Text size="sm" c="dimmed">
              Community First Services and Supports — MN 256B.85
            </Text>
          </Stack>
        </Group>

        {/* Top row - compact summary cards */}
        <SimpleGrid cols={{ base: 1, sm: 2, md: 4 }}>
          <EvvSummaryWidget compact />
          <SupervisionComplianceWidget compact />
          <BudgetUtilizationWidget compact />
          <ServiceHoursWidget compact />
        </SimpleGrid>

        {/* Detail cards */}
        <Grid>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <EvvSummaryWidget />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <SupervisionComplianceWidget />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <BudgetUtilizationWidget />
          </Grid.Col>
          <Grid.Col span={{ base: 12, md: 6 }}>
            <ServiceHoursWidget />
          </Grid.Col>
        </Grid>
      </Stack>
    </Container>
  );
}

export default CfssDashboardPage;
